import { Select } from 'antd5';
import styled from 'styled-components';

export const VendorSelect = styled(Select)`
  min-width: 10rem;
`;

export const AddVendorContainer = styled.div`
  cursor: pointer;
  padding: 0.5rem;

  &:hover {
    background-color: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;
